var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { BaseConfigProvider } from "../providers";
export var logger = {
    log: function (caller) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var isProduction = BaseConfigProvider.sentryEnvironment === "production";
        if (!isProduction) {
            return console.debug.apply(console, __spreadArray(["[".concat(caller, "]")], __read(args), false));
        }
        console.debug("[".concat(caller, "]"), JSON.stringify(args));
    },
    time: function (caller, name) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        logger.log.apply(logger, __spreadArray([caller, name], __read(args), false));
        console.time("[".concat(caller, "] ").concat(name, " "));
    },
    timeEnd: function (caller, name) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        logger.log.apply(logger, __spreadArray([caller, name], __read(args), false));
        console.timeEnd("[".concat(caller, "] ").concat(name, " "));
    },
};
//# sourceMappingURL=logger.helper.js.map